import Events from '@/assets/events.png';
import Events1 from '@/assets/events/events1.png';
import Events2 from '@/assets/events/events2.png';
import Events3 from '@/assets/events/events3.png';
import Events4 from '@/assets/events/events4.png';

import Games from '@/assets/games.png';
import Games1 from '@/assets/games/games-1.jpg';
import Games2 from '@/assets/games/games-2.jpg';
import Games3 from '@/assets/games/games-3.jpg';

import RhythmBlast from '@/assets/space_sticker.png';
import RhythmBlast1 from '@/assets/blast/blast-1.jpg';
import RhythmBlast2 from '@/assets/blast/blast-2.jpg';
import RhythmBlast3 from '@/assets/blast/blast-3.jpg';

export default {
  'Rhythm Blast': {
    thumbnail: RhythmBlast,
    imageWidth: 300,
    images: [
      RhythmBlast1,
      RhythmBlast2,
      RhythmBlast3,
    ],
    projectLink: 'https://glitchless.surge.sh',
    description: 'Веб-игра - арканоид в космическом сеттинге, с динамичной графикой и уникальным геймплеем. Вы - пилот корабля, который застрял на орбите вместе с кораблями враждующих фракций.\n'
      + '\n'
      + 'Разгромите их, используя законы физики и гравиплатформы. Снимите щит у врага и уничтожьте его!',
    paddedThumb: true,
  },
  '«Актуальные события»': {
    thumbnail: Events,
    images: [
      Events1,
      Events2,
      Events3,
      Events4,
    ],
    projectLink: 'https://vk.com/activities',
    description: 'Приложение для поиска событий в соответствии с предпочтениями и местоположением пользователя, а также напоминания об уже запланированных ивентах. \n'
      + '\n'
      + 'Теперь вы никогда не забудете, куда хотели пойти!',
  },
  'games.glitchless.ru': {
    thumbnail: Games,
    imageWidth: 300,
    images: [
      Games1,
      Games2,
      Games3,
    ],
    projectLink: 'https://games.glitchless.ru',
    description: 'Портал игрового направления нашей команды. Пока что здесь можно найти только сервер по Minecraft для зарегистрированных пользователей, но в будущем мы планируем расширять список игр.'
    + '\n\n'
    + 'Свои предложения по его расширению и улучшению вы можете оставить в обратную связь на портале или в телеграм @StealthTech.',
  },
};
